export const getRandomNumber = (): number => {
  return Math.floor(Math.random() * 100000);
};
